import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import {
  addCommodityGroup,
  getCommodityGroups,
  updateCommodityGroup,
  deleteCommodityGroup,
} from "./commodityGroupAPI";

const initialState = {
  loading: false,
  commodityGroupList: [],
  pagination: {},
};

const actions = {
  CREATE_COMMODITY_GROUP: "commodityGroup/CREATE_COMMODITY_GROUP",
  GET_COMMODITY_GROUPS: "commodityGroup/GET_COMMODITY_GROUPS",
  UPDATE_COMMODITY_GROUP: "commodityGroup/UPDATE_COMMODITY_GROUP",
  DELETE_COMMODITY_GROUP: "commodityGroup/DELETE_COMMODITY_GROUP",
};

export const createCommodityGroupThunk = createAsyncThunk(
  actions.CREATE_COMMODITY_GROUP,
  async (payload) => {
    const response = await addCommodityGroup(payload);
    return response;
  }
);

export const getCommodityGroupsThunk = createAsyncThunk(
  actions.GET_COMMODITY_GROUPS,
  async (payload) => {
    const response = await getCommodityGroups(
      payload?.page,
      payload?.per_page,
      payload?.search
    );
    return response;
  }
);

export const updateCommodityGroupThunk = createAsyncThunk(
  actions.UPDATE_COMMODITY_GROUP,
  async ({ id, ...payload }) => {
    const response = await updateCommodityGroup(id, payload);
    return response;
  }
);

export const deleteCommodityGroupThunk = createAsyncThunk(
  actions.DELETE_COMMODITY_GROUP,
  async (id) => {
    const response = await deleteCommodityGroup(id);
    return response;
  }
);

export const commodityGroupSlice = createSlice({
  name: "commodityGroup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCommodityGroupThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCommodityGroupThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Commodity Group created successfully!");
        } else {
          message.error(msg || "Failed to create Commodity Group.");
        }
      })
      .addCase(createCommodityGroupThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to create Commodity Group.");
      });

    builder
      .addCase(getCommodityGroupsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCommodityGroupsThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg, data } = action.payload;
        if (success) {
          state.commodityGroupList = data?.data || [];
          state.pagination = data?.pagination || {};
        } else {
          message.error(msg || "Failed to fetch Commodity Groups.");
        }
      })
      .addCase(getCommodityGroupsThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to fetch Commodity Groups.");
      });

    builder
      .addCase(updateCommodityGroupThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCommodityGroupThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Commodity Group updated successfully!");
        } else {
          message.error(msg || "Failed to update Commodity Group.");
        }
      })
      .addCase(updateCommodityGroupThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to update Commodity Group.");
      });

    builder
      .addCase(deleteCommodityGroupThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCommodityGroupThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Commodity Group deleted successfully!");
        } else {
          message.error(msg || "Failed to delete Commodity Group.");
        }
      })
      .addCase(deleteCommodityGroupThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to delete Commodity Group.");
      });
  },
});

export default commodityGroupSlice.reducer;
